/**
 * Project : workspace
 * File    : AppNavGraph.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package navigation.graph

import androidx.compose.runtime.Composable
import androidx.navigation.NavGraph
import androidx.navigation.createGraph
import navigation.base.FriendlyWindow
import navigation.commerce.graph.EcommerceHomeNavGraph
import navigation.graph.account.AccountNavGraph
import navigation.graph.business.BusinessNavGraph
import navigation.graph.common.CommonNavGraph
import navigation.graph.employee.EmployeeNavGraph
import navigation.graph.inventory.InventoryNavGraph
import navigation.graph.inventory.customer.CustomerNavGraph
import navigation.graph.invoice.InvoiceNavGraph
import navigation.graph.order.OrderNavGraph
import navigation.graph.policy.PolicyNavGraph
import navigation.graph.relation.RelationNavGraph
import navigation.graph.sale.SaleNavGraph
import navigation.graph.store.StoreNavGraph
import navigation.route.business.BusinessNavRoute

/**
 * Represents the app nav graph class.
 */

class AppNavGraph {
    @Composable
    fun appNavigationGraph(start : String = BusinessNavRoute.HOME): NavGraph {
        var startRoute = ""
        if(start.isEmpty()){
            startRoute = BusinessNavRoute.HOME
        }else{
            startRoute = start
        }
        val graph =
            FriendlyWindow.navigationController?.createGraph(startDestination = startRoute) {}
        graph?.addAll(CommonNavGraph().navGraph())
        graph?.addAll(BusinessNavGraph().navGraph(startRoute))
        graph?.addAll(EcommerceHomeNavGraph().navGraph())
        graph?.addAll(BusinessNavGraph().onboarding())
        graph?.addAll(RelationNavGraph().navGraph())
        graph?.addAll(CustomerNavGraph().navGraph())
        graph?.addAll(EmployeeNavGraph().navGraph())
        graph?.addAll(InventoryNavGraph().navGraph())
        graph?.addAll(StoreNavGraph().navGraph())
        graph?.addAll(OrderNavGraph().navGraph())
        graph?.addAll(SaleNavGraph().navGraph())
        graph?.addAll(InvoiceNavGraph().navGraph())
        graph?.addAll(PolicyNavGraph().navGraph())
        graph?.addAll(AccountNavGraph().navGraph())
        FriendlyWindow.navGraph = graph
        return graph!!
    }
}